import { tv } from 'tailwind-variants';

const rootStyle = tv({
  base: '',
});

const itemStyle = tv({
  base: 'pl-2',
});

const headerStyle = tv({
  base: 'h-9 text-white mt-4 mb-2',
});

const triggerStyle = tv({
  base: 'flex gap-x-3 items-center font-semibold group',
});

const contentStyle = tv({
  base: 'grid items-center w-full data-[state=open]:animate-accordion-slide-down overflow-hidden',
});
// slide-up animation bug
// const contentStyle = tv({
//   base: 'grid items-center w-full data-[state=open]:animate-accordion-slide-down data-[state=closed]:animate-accordion-slide-up overflow-hidden',
// });

export const accordionStyle = {
  root: rootStyle,
  item: itemStyle,
  header: headerStyle,
  trigger: triggerStyle,
  content: contentStyle,
};
